// Angular
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

const routes: Routes = [
	{ path: 'auth', loadChildren: 'app/views/pages/auth/auth.module#AuthModule' },
	{ path: 'nomade_client', loadChildren: 'app/views/partials/content/nomade/nomade-client.module#NomadeClientModule' },

	// enable this router to set which demo theme to load,
	// leave the path value empty to enter into nested router in ThemeModule

	/** START: remove this themes list on production */
	{ path: '', redirectTo: 'home', pathMatch: 'full' },
	// list of routers specified by demos, for demo purpose only!
	{ path: 'home', loadChildren: 'app/views/themes/theme.module#ThemeModule' },

	/** END: themes list end */

	{ path: '**', redirectTo: 'home', pathMatch: 'full' }
]

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
